/**
 * Presentational: step labels below the card (Organization Details / Primary Administrator).
 * Single Responsibility: render labels; active step has full opacity.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_COPY } from '../constants';

const LABEL_CLASS = 'text-[12px] font-medium text-[#6e6e71]';
const ACTIVE_OPACITY = 'opacity-100';
const INACTIVE_OPACITY = 'opacity-40';

const STEP_LABELS = [
  PAGE_COPY.STEP_LABEL_ORGANIZATION,
  PAGE_COPY.STEP_LABEL_ADMIN,
];

export function StepLabels({ currentStep }) {
  return (
    <div className="mt-6 flex justify-center gap-12">
      {STEP_LABELS.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        return (
          <div
            key={stepNumber}
            className={`text-center transition-opacity ${isActive ? ACTIVE_OPACITY : INACTIVE_OPACITY}`}
          >
            <p className={LABEL_CLASS}>{label}</p>
          </div>
        );
      })}
    </div>
  );
}

StepLabels.propTypes = {
  currentStep: PropTypes.number.isRequired,
};
